// import mergeDeep from '@/core/shared/helpers/mergeDeep'

export const setLocations = (state, locations) => {
  state.locations = locations;
};
